var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-item",on:{"click":_vm.onClickItem}},[_c('i',{staticClass:"material-icons"},[_vm._v("add")]),_c('span',{class:{ required: _vm.requiredItem },domProps:{"innerHTML":_vm._s(_vm.addItemText)}}),(_vm.needMoreInfo)?_c('div',{staticClass:"need-edit"},[_vm._v("작성중")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }